import React from 'react';
import InputMask from "react-input-mask";
import './style.css';
import Validation from '../Validation';
import InputWithIcon from '../Input/InputWithIcon';

const MobileInputContainer = props => {
    const { inputLabel, showValidation, validationMessage, inputValue, changeHandler, className, needMask, inputWithSymbol, hideHeader, maskValue } = props;
    const classes = className ? `${className} input-block-validation` : 'input-block-validation';
    return (
        <div className={classes}>
            <div className={inputWithSymbol ? `input-container-amount` : `input-container`}>
                <h3 className={hideHeader ? `hide` : `input-container-header greenColor`}>{inputLabel}</h3>
                {
                    needMask ?
                        (
                            <label htmlFor="input-mobile-container" aria-label="input-text">
                            <InputMask mask={maskValue}
                                type="text"
                                inputMode='numeric'
                                pattern="[0-9]*"
                                placeholder={""}
                                className="input-container-input"
                                onChange={(e) => changeHandler(e)}
                                value={inputValue}
                                tabIndex={0}
                            />
                             </label>
                        ) :
                        inputWithSymbol ? (
                            <InputWithIcon value={inputValue}
                                placeholder={"Enter Amount"}
                                onChange={(e) => changeHandler(e)}
                                onBlur={props.onBlur}
                                tabIndex={0}
                            />
                        ) : (
                                <label htmlFor="input-mobile-container" className="label-FullWidth" aria-label="input-text">
                                    <input
                                        id="input-mobile-container"
                                        className="input-container-input input-FullWidth-Email"
                                        value={inputValue}
                                        onChange={(e) => changeHandler(e)}
                                        onBlur={props.onBlur}
                                        tabIndex={0}
                                    />
                                </label>
                            )
                }
            </div>
            {
                !showValidation &&
                <Validation
                    message={validationMessage}
                    messageId={`${inputLabel}id`}
                />
            }
        </div>
    )
};

export default MobileInputContainer;
